import React from 'react';
// import nextId from '../../services/NextID.service';
import DateSelector from '../dateSelector/DateSelectorController';
import './widget.css';

// function renderSelect(config) {
// 	const { propertyName = 'selectedLessonType', placeholderText = 'Choose your Lesson Type', data = [], onChange, selectedValue } = config;
// 	return (
// 		<div key={nextId()}>
// 			<select id="resort-selector" name={propertyName} defaultValue={selectedValue} onChange={(e) => onChange(e)} required>
// 				<option value="" disabled>{placeholderText}</option>
// 				{data.map(res => { return <option key={nextId()} value={res.id}>{res.name}</option> })}
// 			</select>
// 		</div>
// 	);
// }

function renderDate(config) {
	const { propertyName = 'startDate', minDate = new Date().toISOString().substr(0, 10), placeholderText = 'date', onChange, selectedValue } = config;
	if (window.__desktop_safari_detected) {
		return <DateSelector name={propertyName} value={selectedValue} required min={minDate} placeholder={placeholderText} onChange={onChange} />;
	}
	// eslint-disable-next-line
	const classname = 'placeholder ' + (config.selectedValue!=''?'has-value':'');	
	return <input className={classname} name={propertyName} type="date" required placeholder={placeholderText} onChange={(e) => onChange(e)} />;
}

class WidgetView extends React.Component {

	render() {
		const { resorts, onSubmit, onChange, selectedResort="", dateEnd, dateStart } = this.props;
		return (
			<React.Fragment>

				<div className="container">
					<h1>INSTRUCTORS & ADVENTURE ON DEMAND</h1>
					<h2>Find your perfect ski instructor or school.</h2>
					<form className="form" onSubmit={(e)=>onSubmit(e)}>

						<div className="control text-field select">
							<select id="resort-selector" name="selectedResort" value={selectedResort} onChange={(e) => onChange(e)} required>
								<option value="" default disabled>Select Resort</option>
								{resorts.length===0?<option style={{fontStyle:'italic'}} id="loading-notice" disabled>Loading resorts...</option>:''}
								{resorts.map(resort=>(<option value={resort.id}>{resort.name}</option>))}								
							</select>
							{/* {renderSelect({propertyName: 'resort', placeholderText: 'Select Resort', data: resorts, selectedValue: selectedResort, onChange})} */}
						</div>

						<div className="control text-field date">
							{renderDate({ propertyName: 'dateStart', placeholderText: 'Start Date', selectedValue: dateStart, onChange })}
						</div>

						<div className="control text-field date ">
							{renderDate({ propertyName: 'dateEnd', placeholderText: 'End Date', selectedValue: dateEnd, onChange })}
						</div>

						<button type="submit" className="control search button">search</button>

					</form>
				</div>
			</React.Fragment>
		);
	}
}

export default WidgetView;


// WEBPACK FOOTER //
// ./src/components/widgetv3/WidgetView.js